import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DynamicTitle = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) {
      document.title = "Lash - Panel de Administración";
    } else {
      document.title = "Lash - Odontología Integral";
    }
  }, [location]);

  return null; // No renderiza nada, solo cambia el título
};

export default DynamicTitle;
